package com.example.mystybag.appCore.views.pages

import androidx.compose.runtime.Composable
import com.example.mystybag.appCore.logic.pages.MerchantLocationsListViewModel

@Composable
fun MerchantLocationsListWebView(viewModel: MerchantLocationsListViewModel) {
    ComingSoonWebView()
}
